"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function SparkleEmptyBlockMobileSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 53, height: 85, viewBox: "0 0 53 85", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Sparkle-empty-block-mobile", clipPath: "url(#clip0_213_2161)" },
            react_1.default.createElement("g", { id: "Group 1000002855" },
                react_1.default.createElement("path", { id: "Vector", d: "M19.7693 81.5251C22.3286 77.9806 24.5463 68.797 18.9404 64.7493", stroke: "black", strokeWidth: 4.61701, strokeLinejoin: "round" }),
                react_1.default.createElement("path", { id: "Vector_2", d: "M19.819 81.5163C22.3588 77.9578 30.3507 72.9195 35.9787 76.9363", stroke: "black", strokeWidth: 4.61701, strokeLinejoin: "round" }),
                react_1.default.createElement("path", { id: "Vector 819", d: "M26.3055 3.10363C41.8443 27.2055 38.2825 55.7233 24.4591 74.8976", stroke: "#FFD552", strokeWidth: 4.61895 }),
                react_1.default.createElement("path", { id: "Vector 819_2", d: "M24.4591 74.8974C34.6047 60.8246 39.2226 41.7188 34.8184 23.0197", stroke: "#659675", strokeWidth: 4.61895 }),
                react_1.default.createElement("path", { id: "Vector 819_3", d: "M24.4591 74.8976C28.9219 68.7073 32.3151 61.5432 34.3414 53.8682", stroke: "black", strokeWidth: 4.61895 }))),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_213_2161" },
                react_1.default.createElement("rect", { width: 52, height: 85, fill: "white", transform: "translate(0.5)" }))));
}
function SparkleEmptyBlockMobile(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(SparkleEmptyBlockMobileSvg, Object.assign({}, svgProps)));
}
exports.default = SparkleEmptyBlockMobile;
//# sourceMappingURL=SparkleEmptyBlockMobile.js.map